import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { Input, Button, Form, message } from 'mk-pc'
import { getKey } from '../service'
import { encrypt } from '@/lib/encrypt'
import { useAuth } from '@/hooks'
import logoImage from '@/assets/images/logo.png'
import '../styles/login.scss'

/**
 * 登录
 * @returns
 */
export const Login = () => {
  const { userLogin } = useAuth()
  const { search } = useLocation()
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)

  /**
   * 获取回跳地址
   * @returns
   */
  const getRedirect = () => {
    const params = search.replace(/\?/g, '').split('&')
    let url = ''
    for (const param of params) {
      const [key, value] = param.split('=')
      if (key === 'redirect') {
        url = value
        break
      }
    }
    return url
  }
  /**
   * 登录提交
   */
  const handleSubmit = async () => {
    try {
      const formData = await form.validateFields()
      const publicKey = await getKey()
      const encryotPassword = encrypt(formData.password, publicKey as unknown as string)
      const redirect = getRedirect()

      setLoading(true)

      await userLogin(formData.account, encryotPassword)
      setLoading(false)
      // 获取地址栏的redirect 进行跳转
      window.location.replace(redirect ? decodeURIComponent(redirect) : '/')
    } catch (e: any) {
      setLoading(false)
      switch (e.errorcode) {
        case 10001:
          form.setFields([
            {
              name: 'password', // 对应表单项的 name 属性
              errors: [e.message] // 设置错误信息
            }
          ])
          break
        default:
          message.error(e.message)
          break
      }
    }
  }

  return (
    <section className="login">
      <section className="login-image"></section>
      <section className="login-form">
        <header>
          <img className="login-logo" src={logoImage} /> 奇孚
        </header>
        <section className="login-form__content">
          <div className="login-form__content-wrap">
            <h2>内容管理平台</h2>
            <h4>用科技改善生活</h4>
            <Form name="basic" form={form} wrapperCol={{ span: 24 }} autoComplete="off" onFinish={handleSubmit}>
              <Form.Item
                name="account"
                rules={[
                  { required: true, message: '请输入登录账号！' },
                  { type: 'string', min: 2, max: 20, message: '登录账号长度在 2-20 之间！' },
                  { pattern: /^\w+$/, message: '登录账号格式不正确' }
                ]}
              >
                <Input placeholder="请输入登录账号" />
              </Form.Item>

              <Form.Item name="password" rules={[{ required: true, message: '请输入密码！' }]}>
                <Input.Password placeholder="请输入密码" />
              </Form.Item>
              <Form.Item className="login-form__submit">
                <Button type="primary" htmlType="submit" block loading={loading}>
                  登 录
                </Button>
              </Form.Item>
            </Form>
          </div>
        </section>
      </section>
    </section>
    // <section className="login">
    //   <div className="login-slogan">
    //     <Gallery autoPlay images={[{ original: slogan1 }, { original: slogan2 }]} />
    //   </div>
    //   <div className="login-form">
    //     <div className="login-form__content">
    //       <div className="login-form__content-logo" style={{ textAlign: 'center' }}>
    //         <span className="logo" style={{ width: 308, height: 54 }}></span>
    //       </div>
    //       <h3>欢迎登录</h3>
    //       <Form name="basic" layout="vertical" form={form} initialValues={{ account: '', password: '', code: '' }} autoComplete="off">
    //         <Form.Item name="account" rules={[{ required: true, message: '请输入登录账号' }]}>
    //           <Input style={{ height: 42 }} placeholder="登录账号" />
    //         </Form.Item>
    //         <Form.Item name="password" rules={[{ required: true, message: '请输入登录密码' }]}>
    //           <Input type="password" style={{ height: 42 }} placeholder="登录密码" />
    //         </Form.Item>
    //         <Form.Item name="code" rules={[{ required: true, message: '请输入验证码' }]}>
    //           <div className="code-wrap">
    //             <div className="code-input">
    //               <Input style={{ height: 42 }} placeholder="验证码" />
    //             </div>
    //             <div className="code-image" onClick={fetchVerifyCode}>
    //               {imageData.data && <img src={'data:image/svg+xml;base64,' + imageData.data} />}
    //             </div>
    //           </div>
    //         </Form.Item>
    //       </Form>
    //       <Button type="primary" className="login-form__submit" onClick={handleSubmit}>
    //         登 录
    //       </Button>
    //     </div>
    //   </div>
    // </section>
  )
}
